module.exports = "./b06871f281fee6b241d60582ae9369b9.ttf";